import * as zod from 'zod'

export const generateInvoiceFlowSchema = zod
  .object({
    companyId: zod.number({ invalid_type_error: 'Company is required' }),
    startsAt: zod
      .string({ required_error: 'Start is required' })
      .min(1, 'Start is required'),
    endsAt: zod
      .string({ required_error: 'End is required' })
      .min(1, 'End is required'),
  })
  .superRefine((data, ctx) => {
    const startsAt = new Date(data.startsAt)
    const endsAt = new Date(data.endsAt)
    if (Number.isNaN(startsAt.getTime())) {
      ctx.addIssue({
        code: zod.ZodIssueCode.custom,
        path: ['startsAt'],
        message: 'Start must be a valid date/time',
      })
    }
    if (Number.isNaN(endsAt.getTime())) {
      ctx.addIssue({
        code: zod.ZodIssueCode.custom,
        path: ['endsAt'],
        message: 'End must be a valid date/time',
      })
    }
    if (
      !Number.isNaN(startsAt.getTime()) &&
      !Number.isNaN(endsAt.getTime()) &&
      endsAt < startsAt
    ) {
      ctx.addIssue({
        code: zod.ZodIssueCode.custom,
        path: ['endsAt'],
        message: 'End must be on or after start',
      })
    }
  })

export type GenerateInvoiceFlowSchema = zod.infer<
  typeof generateInvoiceFlowSchema
>
